import { render, staticRenderFns } from "./CmgOrderCard.vue?vue&type=template&id=6a72c979&scoped=true&lang=pug&"
import script from "./cmg-order-card.ts?vue&type=script&lang=ts&"
export * from "./cmg-order-card.ts?vue&type=script&lang=ts&"
import style0 from "./CmgOrderCard.vue?vue&type=style&index=0&id=6a72c979&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a72c979",
  null
  
)

export default component.exports